<!--  -->
<template>
  <div class="wrap">
    <div class="weixin-tip" v-if="tipShow">
      <p><img src="@/assets/live_weixin.png" alt="微信打开" /></p>
    </div>
    <img class="center-img" src="@/assets/down_app_content.png" alt="" />
    <div class="con">
      <img
        @click="downiOSClick"
        class="down-btn"
        src="@/assets/down_ios_online.png"
        alt=""
      />
      <img
        @click="downAndroidClick"
        class="down-btn"
        src="@/assets/down_android_online.png"
        alt=""
      />
      <span class="footer-text">北京优优英才文化传播有限公司 ｜ 京ICP备2025115288号-2A</span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isAndroid: "",
      isiOS: "",
      tipShow: false,
    };
  },
  created: function () {
    let u = navigator.userAgent;
    this.isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
    this.isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    this.is_weixin();
  },
  methods: {
    downAndroidClick() {
      window.location.href = "https://obs.yyyc.englishtalents.com/apk/yyyc.apk";
    },
    downiOSClick() {
      const isIPad =
      /iPad/i.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
      if (isIPad) {
        window.location.href = "https://apps.apple.com/cn/app/%E4%BC%98%E4%BC%98%E8%8B%B1%E6%89%8D-hd/id6770416016";
        return;
      }
      window.location.href = "https://apps.apple.com/us/app/%E4%BC%98%E4%BC%98%E8%8B%B1%E6%89%8D/id6745240687";
    },
    is_weixin() {
      let ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        this.tipShow = true;
      } else {
        this.tipShow = false;
      }
    },
  },
};
</script>

<style scoped>
.wrap {
  width: 100%;
  height: 100%;
  background: url("~@/assets/down_app_01_bg.png") no-repeat;
  background-size: 100% 100%;
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.center-img {
  display: block;
  margin: 45% auto 0;
  width: 290px;
  flex-shrink: 0;
}

.con {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  padding: 20px;
  gap: 14px;
  text-align: center;
}

.down-btn {
  display: block;
  width: 240px;
  height: auto;
  flex-shrink: 0;
}

.footer-text {
  color: white;
  font-size: 11px;
  padding: 20px 0px 0;
  word-break: break-word;
  flex-shrink: 0;
}

.weixin-tip {
  position: fixed;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.8);
  filter: alpha(opacity=80);
  width: 100%;
  height: 100%;
  z-index: 100;
}

.weixin-tip p {
  text-align: center;
  margin-top: 10%;
  padding: 0 5%;
}

.weixin-tip img {
  width: 100%;
}

/* 横屏适配 */
@media (orientation: landscape) {
  .center-img {
    width: 200px;
    margin: 80px auto 0;
  }

  .con {
    padding: 10px;
    gap: 10px;
  }

  .down-btn {
    width: 180px;
  }

  .footer-text {
    font-size: 11px;
    padding: 10px 5px 0;
  }
}
</style>